import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary, UiProvider, installGlobalErrorHandlers } from '@figma-importers/ui'
import App from './App.tsx'

const APP_NAME = 'eps-to-figma'

// Capture uncaught errors + unhandled rejections before the first render.
installGlobalErrorHandlers({ app: APP_NAME })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <UiProvider>
      <ErrorBoundary app={APP_NAME}>
        <App />
      </ErrorBoundary>
    </UiProvider>
  </StrictMode>,
)
